











































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import Gtm from '@/types/gtm';

@Component({
  components: {
    DocIcon,
  },
})
export default class Footer extends Vue {
  $gtm: Gtm;
  get currentYear() {
    return new Date().getFullYear();
  }

  get content() {
    const lang = (process.env.VUE_APP_DOMAIN as 'ru' | 'en' | 'kz' | undefined) || 'en';
    const content: Record<'ru' | 'en' | 'kz', unknown> = {
      ru: {
        copyrightTitle: `© ${this.currentYear} Voximplant®. Все права защищены.`,
        copyrightAddress: 'ООО Фастком Москва, Мытная 66, 2й этаж, 115191',
        needHelp: 'Нужна помощь?',
        haveQuestions: 'В случае возникновения вопросов, обращайтесь в нашу ',
        techSupport: 'службу поддержи',
        findUs: ' или ищите нас по ',
        voximplantTag: 'тегу Voximplant',
        forAnswers: ' на Stack Overflow для получения ответов на общие вопросы.',
      },
      kz: {
        copyrightTitle: `© ${this.currentYear} Voximplant®. Все права защищены.`,
        copyrightAddress:
          'ТОО «Voximplant KZ (Воксимплант КЗ)», город Астана, улица Тарас Шевченко, здание 4/1, н.п. 17, 010000',
        needHelp: 'Нужна помощь?',
        haveQuestions: 'В случае возникновения вопросов, обращайтесь в нашу ',
        techSupport: 'службу поддержи',
        findUs: ' или ищите нас по ',
        voximplantTag: 'тегу Voximplant',
        forAnswers: ' на Stack Overflow для получения ответов на общие вопросы.',
      },
      en: {
        copyrightTitle: `© ${this.currentYear} Voximplant® All rights reserved.`,
        copyrightAddress:
          '150 West 25th Street, RM 403 New York City, NY 10001, United States of America',
        needHelp: 'Need some help?',
        haveQuestions: 'Feel free to reach our ',
        techSupport: 'support team',
        findUs: ' with any questions, or search for the ',
        voximplantTag: 'Voximplant tag',
        forAnswers: ' on Stack Overflow for common questions and answers.',
      },
    };
    return content[lang];
  }

  sendGtmSupport() {
    this.$sendGtmEvent({
      event: 'vox_docs_ask_support',
      category: 'help',
      action: 'ask_support',
      label: this.$router.currentRoute.path,
    });
  }

  sendGtmStack() {
    this.$sendGtmEvent({
      event: 'vox_docs_stackoverflow_go',
      category: 'help',
      action: 'go_stackoverflow',
      label: this.$router.currentRoute.path,
    });
  }

  sendGtmLinks(link: string) {
    this.$sendGtmEvent({
      event: 'vox_docs_footer_to_other_pages',
      category: 'main_docs_footer',
      action: 'other_pages',
      label: link.toLowerCase(),
    });
  }

  sendGtmSocialMedia(mediaName: string) {
    this.$sendGtmEvent({
      event: 'vox_docs_footer_to_social_media',
      category: 'main_docs_footer',
      action: 'social_media',
      label: mediaName.toLowerCase(),
    });
  }
}
